'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Este servicio no está disponible, vuelve a intentarlo más tarde.',
    NEED_ACTIVE: 'Estás accediendo con la cuenta {{account}} por primera vez en este sitio web. {{activeLink}} para completar el proceso y empezar a explorar ofertas.',
    GOTO_ACTIVE: 'Activar',
    NOT_ACTIVED: 'Ha habido un error al activar la cuenta, {{activeLink}} para finalizar el proceso.',
    COMPLETE_ACTIVE: 'Confirmar activación',
    FORBID_ACTIVE: 'Esta cuenta no está disponible en AliExpress.',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Inicia sesión con otra cuenta',
    ACTIVE_PAGE: 'Entra en la página de activación de cuenta'
};